"use client";

import React from "react";
import { gql } from "@apollo/client";
import { cn } from "@jasperlabs/ui";

import { OpenOfferTag } from "./tags";
import { OfferTagsFragment } from "./OfferTags.generated";

export function OfferTags({
	offer,
	className,
}: {
	offer: OfferTagsFragment;
	className?: string;
}) {
	if (offer.status !== "OPEN") {
		return null;
	}

	return (
		<div className={cn("flex flex-wrap gap-2", className)}>
			<OpenOfferTag />
		</div>
	);
}

OfferTags.fragment = gql`
	fragment OfferTags on Offer {
		id
		status
	}
`;
